<div class="pet-link" *ngIf="!suspended" (click)="$event.stopPropagation()">
  <button type="button" class="pet-toggle" (click)="open = !open" [attr.aria-expanded]="open" aria-controls="pet-pairing-panel">✦ 桌面寵物</button>
  <section id="pet-pairing-panel" *ngIf="open" aria-label="桌面寵物配對">
    <strong>北極星桌面寵物</strong>
    <p>僅分享此分頁的摘要類別與生日提示，不分享姓名、證號或病史內容。</p>
    <p>在桌面寵物的設定貼上配對資料。憑證限用一次、兩分鐘內有效，請勿轉傳。</p>
    <button type="button" (click)="pair()" [disabled]="busy">{{ busy ? '產生中…' : '產生配對資料' }}</button>
    <button type="button" *ngIf="active" (click)="disconnect()" [disabled]="busy">停止分享</button>
    <textarea #pairingText *ngIf="pairing" readonly [value]="pairing" aria-label="一次性配對資料" (focus)="pairingText.select()"></textarea>
    <small *ngIf="active">分享已啟用；桌面是否連線請查看寵物設定。</small>
    <p role="alert" *ngIf="error">{{ error }}</p>
  </section>
</div>
